<template>
  <div :class="style.modalAstral" @mousedown="clickOutSide">
    <div :class="containerClassList">
      <span :class="style.modalAstralClose" @click="$emit('close')">&times;</span>
      <div :class="style.modalAstralHeader">
        <h3><slot name="header"></slot></h3>
      </div>
      <div :class="style.modalAstralHeaderSmall">
        <slot name="headerSmall"></slot>
      </div>

      <div :class="style.modalAstralBody">
        <slot></slot>
      </div>
        
      <div :class="style.modalAstralFooter">
        <slot name="footer"></slot>    
      </div>
    </div>
  </div>
</template>

<script>
import style from './style.module.scss'

export default {
  name: 'ModalAstral',
  components: {

  },
  props: {
    size: {
      type: String,
      required: false,
      default: 'sm'
    }
  },
  data() {
    return {
      style: style
    }
  },
  computed: {
    containerClassList() {

      const classList = [this.style.modalAstralContainer];

      switch (this.size) {
      case 'sm':
        classList.push(this.style.modalAstralContainerSm);
        break;
      case 'mid':
        classList.push(this.style.modalAstralContainerMid);
        break;

      case 'lg':
        classList.push(this.style.modalAstralContainerLg);
        break;
      
      default:
        break;
      }
      return classList
    }
  },
  methods: {
    clickOutSide(e) {
      let el = e.target;
      if (el === this.$el) {
        this.$emit('close')
      }
      else return
    }
  }
}
</script>